module.exports = __webpack_public_path__ + "img/彭玉珍.12419195.png";